<div class="inner-page-wrapper">
    <app-sub-nav-legal />
    <div class="py-40 md:py-[80px]">
        <h1 class="mb-24 font-headline text-20 font-medium leading-25 text-black md:mb-40 md:text-34 md:leading-41">
            Impressum
        </h1>
        <div class="app-imprint" editable="imprint.copy">
            <div class="text-16 leading-27 text-black" [innerHTML]="content().copy"></div>
        </div>
    </div>
</div>
